import { types } from 'mobx-state-tree';

const AutomappedBeverage = types.model({
  confidence: types.maybeNull(types.number),
  beverage_id: types.maybeNull(types.integer),
});

const AutomappedContainer = types.model({
  container_id: types.maybeNull(types.integer),
});

export const POSSKU = types.model({
  id: types.integer,
  sku_id: types.maybeNull(types.number),
  item: types.maybeNull(types.string),
  category: types.maybeNull(types.string),
  subcategory: types.maybeNull(types.string),
  latest_price: types.optional(types.number, 0, [null, undefined]),
  latest_price_at: types.maybeNull(types.string),
  ignore: types.maybeNull(types.boolean),
  archived: types.boolean,
  earliest_sale_at: types.maybeNull(types.string),
  latest_sale_at: types.maybeNull(types.string),
  total_sales: types.maybeNull(types.number),
  ignored_at: types.maybeNull(types.string),
  ignored_by: types.maybeNull(types.number),
  matched_at: types.maybeNull(types.string),
  matched_by: types.maybeNull(types.number),
  beverage_id: types.maybeNull(types.number),
  container_id: types.maybeNull(types.number),
  _users_display_name_ignored_by: types.maybeNull(types.string),
  _users_display_name_matched_by: types.maybeNull(types.string),
  auto_mapped_beverages: types.maybeNull(types.array(AutomappedBeverage)),
  auto_mapped_containers: types.maybeNull(types.array(AutomappedContainer)),
});
